<template>
  <b-modal 
    id="modal-delete-participant" 
    centered 
    hide-footer 
    title="Hapus Peserta">
    <div v-if="participant">
      <!-- Warning Icon -->
      <div class="text-center mb-3">
        <i class="fe fe-alert-circle text-danger" style="font-size: 4rem;"></i>
      </div>

      <!-- Confirmation Message -->
      <h5 class="text-center mb-3">Apakah Anda yakin?</h5>
      <p class="text-center text-muted">
        Anda akan menghapus <strong>{{ participant.employee_name }}</strong> ({{ participant.employee_id }}) dari pelatihan ini.
        Tindakan ini tidak dapat dibatalkan.
      </p>

      <!-- Buttons -->
      <div class="d-flex justify-content-end gap-2">
        <button 
          type="button" 
          class="btn btn-secondary"
          @click="closeModal">
          Batal
        </button>
        <button 
          type="button" 
          class="btn btn-danger"
          @click="confirmDelete">
          <i class="fe fe-trash-2 me-1"></i>
          Ya, Hapus
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalDeleteParticipant',
  props: {
    participant: {
      type: Object,
      default: null
    }
  },
  methods: {
    confirmDelete() {
      this.$emit('confirm-delete');
      this.closeModal();
    },

    closeModal() {
      this.$bvModal.hide('modal-delete-participant');
    }
  }
}
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}
</style>
